import { html } from "lit-element";

export const SharedStyles = html`
<style>
    :root,
    :host {
        /* TODO: use common colors here */
        /* --inspx-color-***: #000000; */
    }

    :host {
        display: block;
    }

    *,
    *:before,
    *:after {
        box-sizing: border-box;
    }

    *[hidden],
    .hidden {
        display: none !important;
    }
</style>`;
